module.exports = __webpack_public_path__ + "components/star-rating/static/white/10-6a3cbfced39845cc262ac3af8e4f6b21.svg";